<template>
    <div class="JsEditorMobile my-0 my-lg-4 mx-0 px-0 d-block">
        <!-- Nous contacter -->
        <div id="header-mobile" class="d-flex justify-content-between shadow-pro">
            <a @click="onJsHomeReturn()">
                <img id="logo-mobile" src="@/assets/img/logo-john-steel.svg" height="45px" width="185px" class="p-2">
            </a>
            <div class="bg-gris-pro d-flex align-items-center rounded-bottom-10 mr-3 mb-1" v-b-modal.modal-sav>
                <img id="sav-call" :src="require('@/assets/img/support.svg')" height="20" width="20" class="ml-3">
                <span class="font-weight-bold ml-1 mr-3 mb-0 line-height text-gris"><t JSEditorMobile.sav /></span>
            </div>
        </div>

        <!-- Menu Mobile -->
        <div id="menu-mobile" class="position-absolute w-100">
            <transition-group tag="div" name="slide" class="animated dropdown-menu-mobile d-flex" :class="isDropped != 'cart' && isDropped ? 'slideInUp' : 'slideOutDown'">
                <div class="dropdown-menu-content w-100 mx-2 position-relative overflow-hidden rounded-top-10" key="tool">
                    <div class="bg-gris-pro rounded-top-10 header">
                        <span class="bg-gris w-100 d-block title-rounded text-white py-2 h5 mb-0 font-weight-bold pl-3 pr-1" @click="drop(null)">
                            <div v-if="isDropped == 'tool'" class="d-flex justify-content-between">
                                <span v-if="addType" class="title-menu-mobile"><t JSEditorMobile.createMatter /></span>
                                <span v-else class="title-menu-mobile"><t JSEditorMobile.createCut /></span>
                            </div>
                            <span v-if="isDropped == 'material'" class="title-menu-mobile"><t JSEditorMobile.matters /></span>
                            <span v-if="isDropped == 'setting'" class="d-flex justify-content-between mr-2">
                                <span class="title-menu-mobile">
                                    <t JSEditorMobile.settings />
                                </span>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -10 171.76 200.08" width="23px" height="27px" @click="removeShape(selectedShape)">
                                    <rect class="cls-1" x="50.89" y="1.5" width="63.8" height="34.07" rx="5.6" fill="#ffb400" stroke="#343a40" stroke-width="10" />
                                    <line class="cls-2" x1="64.38" y1="83.13" x2="64.38" y2="153.08" stroke="#343a40" stroke-width="10" stroke-linecap="5"  />
                                    <line class="cls-2" x1="100.38" y1="82.98" x2="100.38" y2="152.93" fill="#343a40" stroke="#343a40" stroke-width="10"/>
                                    <path class="cls-3" d="M202,237.65l13.2-127.39a8.36,8.36,0,0,0-8.33-9.22H93.48a8.37,8.37,0,0,0-8.32,9.29L99.39,237.45a8.37,8.37,0,0,0,8.29,7.44l85.95.26A8.36,8.36,0,0,0,202,237.65Z" transform="translate(-67.62 -57.57)" fill="#ffb400" stroke="#343a40" stroke-width="10" />
                                    <rect class="cls-1" x="1.5" y="26.79" width="161.76" height="24" rx="4.87" fill="#ffb400" stroke="#343a40" stroke-width="10" stroke-miterlimit="10"/>
                                </svg>
                            </span>
                        </span>
                    </div>
                    <div class="d-flex animation bg-white overflow-hidden">
                        <div id="tool" class="animated" data-order="1" :class="isDropped == 'tool' ? enterAnimation : leaveAnimation">
                            <tool-box-mobile v-if="mode == 'workshop'" />
                        </div>
                        <div id="material" class="animated" data-order="2" :class="isDropped == 'material' ? enterAnimation : leaveAnimation">
                            <materials-choice />
                        </div>
                        <div id="setting" class="animated" data-order="3" :class="isDropped == 'setting' ? enterAnimation : leaveAnimation">
                            <properties-box-mobile />
                        </div>
                    </div>
                </div>
            </transition-group>
            <div class="px-2 mb-2 d-flex" id="solid-menu">
                <div class="w-75 rounded-left-10 my-2 shadow-pro" :class="this.pieceInError ? 'bg-jaune' : ''">
                    <div class="bg-gris-pro h-100 d-flex align-items-end justify-content-around py-1 rounded-left-10" :class="{'cart-open' : isDropped == 'cart'}">
                        <div id="mobile-tools" class="position-inherit rounded-10 px-0 menu-mobile-item col-4">
                            <b-button class="dropdown-menu-title ml-2" @click="drop('tool')">
                                <svg class="d-block mx-auto" :class="{'active' : isDropped == 'tool'}" id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="-6 -3 73 65">
                                    <path class="cls-1" d="M24.38,1.42,1.14,44.3a.75.75,0,0,0,.67,1.11H48.29A.75.75,0,0,0,49,44.3L25.71,1.42A.76.76,0,0,0,24.38,1.42Z" fill="#f3f3f3" stroke="#646363" stroke-width="2" />
                                    <rect class="cls-2" x="26.02" y="25.01" width="25.94" height="25.94" rx="1.43"  fill="#f3f3f3" stroke="#646363" stroke-width="2" />
                                    <circle class="cls-2" cx="54.95" cy="46.97" r="10.1" fill="#f3f3f3" stroke="#646363" stroke-width="2" />
                                </svg>
                                <label class="text-dark mb-0"><t JSEditorMobile.tools /></label>
                            </b-button>
                        </div>

                        <div id="mobile-matters" class="position-inherit rounded-10 px-0 menu-mobile-item col-4">
                            <b-button class="dropdown-menu-title mx-2" @click="drop('material')">
                                <svg class="d-block mx-auto" :class="{'active' : isDropped == 'material'}" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -15 79 77" width="37">
                                    <path d="M3,1.37H36.33a3,3,0,0,1,3,3V37.7a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V4.35A3,3,0,0,1,3,1.37Zm9.35,1.19A104.65,104.65,0,0,0,7.74,19.34Q6.48,26.6,10.56,39.49H20.2a7,7,0,0,0-.64-1.85c-.26-.56-1.43-2.79-1.63-3.19a20.88,20.88,0,0,1-2.44-9.85c0-3.6.8-6.33,3-11.76.5-1.24.61-1.49.82-2a24.36,24.36,0,0,0,2.1-8.25Zm-1.26,0H3A1.79,1.79,0,0,0,1.19,4.34h0V37.7A1.79,1.79,0,0,0,3,39.49H9.31q-4-12.89-2.75-20.35A103.41,103.41,0,0,1,11.07,2.56Zm16.34,0H22.62a25.56,25.56,0,0,1-2.18,8.68c-.22.56-.32.81-.83,2-2.17,5.3-2.93,7.91-2.93,11.31A19.57,19.57,0,0,0,19,33.92c.19.38,1.37,2.62,1.64,3.21a8,8,0,0,1,.76,2.36h7.23a8,8,0,0,1,.76-2.36c.27-.59,1.45-2.83,1.64-3.21a19.57,19.57,0,0,0,2.32-9.32c0-3.4-.76-6-2.93-11.31-.51-1.24-.61-1.5-.83-2a25.56,25.56,0,0,1-2.18-8.68Zm1.19,0a24.25,24.25,0,0,0,2.1,8.24l.82,2c2.23,5.44,3,8.17,3,11.77a20.65,20.65,0,0,1-2.44,9.85c-.2.4-1.37,2.62-1.63,3.19a7.44,7.44,0,0,0-.64,1.84h6.5a1.77,1.77,0,0,0,1.79-1.78h0V4.35a1.79,1.79,0,0,0-1.79-1.79H28.6ZM25,31.15c-2.11,0-3.57-3.5-3.57-7.74S22.9,15.66,25,15.66s3.58,3.5,3.58,7.75S27.13,31.15,25,31.15ZM25,30c1.18,0,2.39-2.91,2.39-6.55S26.19,16.85,25,16.85s-2.38,2.91-2.38,6.56S23.84,30,25,30Z" transform="translate(0 -1.37)" stroke="#646363" stroke-width="1.2" />
                                    <rect x="26.21" y="14.37" width="39.79" height="40.89" rx="5.53" stroke="#646363" stroke-width="2" fill="#f3f3f3" />
                                </svg>
                                <label class="text-dark mb-0"><t JSEditorMobile.matter /></label>
                            </b-button>
                        </div>

                        <div id="mobile-settings" class="position-inherit rounded-10 px-0 menu-mobile-item col-4" :class="{'disabled' : !selectedShapeIds.length}">
                            <b-button class="dropdown-menu-title mr-2" @click="drop('setting')">
                                <svg class="d-block mx-auto" :class="{'active' : selectedShapeIds.length}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.25 37.22" width="29">
                                    <rect y="3.71" width="50.25" height="1.94" rx="0.97" fill="#646363" />
                                    <rect y="17.54" width="50.25" height="1.94" rx="0.97" fill="#646363" />
                                    <rect y="31.57" width="50.25" height="1.94" rx="0.97" fill="#646363" />
                                    <circle id="one" cx="21.64" cy="32.54" r="3.68" stroke="#646363" stroke-width="2" fill="#f3f3f3" />
                                    <circle id="two" cx="11.33" cy="4.68" r="3.68" stroke="#646363" stroke-width="2" fill="#f3f3f3" />
                                    <circle id="three" cx="35.76" cy="18.51" r="3.68" stroke="#646363" stroke-width="2" fill="#f3f3f3" />
                                </svg>
                                <label class="text-dark mb-0"><t JSEditorMobile.settings /></label>
                            </b-button>
                        </div>
                    </div>
                </div>
                <div id="mobile-cart" class="position-inherit rounded-10 bg-gris p-2 p-sm-3 w-25" :class="[pieces.length ? 'filled' : 'disabled', {'pieceInError' : this.pieceInError}]" >
                    <b-button class="dropdown-menu-title d-flex flex-column justify-content-center h-100 w-100 align-items-center" :class="{'active' : isDropped == 'cart'}" @click="drop('cart')" :disabled="!pieces.length">
                        <div id="cart-mobile" class="position-relative mx-auto">
                            <img class="d-block mx-auto w-100 h-100" src="@/assets/img/panier-mobile-gris.png" height="35" v-if="this.pieceInError">
                            <img class="d-block mx-auto w-100 h-100" src="@/assets/img/panier-mobile.png" height="35" v-else>

                            <span id="qty" class="animated swing" v-if="this.pieceInError">!</span>
                            <span id="qty" v-else>{{pieces.length}}</span>
                        </div>
                        <label class="text-white font-weight-bold mb-0 w-100" v-if="!totalPrice"><t JSEditorMobile.pieces /></label>
                        <label class="text-white font-weight-bold mb-0 w-100" v-else>{{Math.round(totalPrice * 100) / 100}}€</label>
                    </b-button>
                    <transition name="slidecart">
                        <div class="dropdown-menu-content addtocart mt-0 mt-sm-2 bg-white" v-show="isDropped == 'cart'">
                            <add-to-cart />
                            <div id="scroll" ref="scroll"></div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { BModal, BButton, VBModal, VBToggle, BIcon, BIconEnvelope, BIconTelephone, BFormCheckbox } from 'bootstrap-vue';
import ToolBoxMobile from './ToolBoxMobile.vue';
import PropertiesBoxMobile from './PropertiesBoxMobile.vue';
import MaterialsChoice from './MaterialsChoice.vue';
import AddToCart from './AddToCart.vue';
import { mapGetters } from 'vuex';
import PathUtils from '../../services/PathUtils';
import paper from 'paper';
import { Layer } from 'paper';

export default {
    components: {
        BModal,
        BButton,
        ToolBoxMobile,
        PropertiesBoxMobile,
        MaterialsChoice,
        AddToCart,
        BIcon,
        BFormCheckbox,
        // eslint-disable-next-line vue/no-unused-components
        VBModal, VBToggle, BIconEnvelope, BIconTelephone
    },
    directives: {
        'b-modal': VBModal,
        'b-toggle': VBToggle },
    data() {
        return {
            lastOrder: null,
            newOrder: null,
            enterAnimation: null,
            leaveAnimation: null,
            addType: null,
            color: null,
            pieceInError: false
        }
    },
    created() {
        addEventListener('scroll', () => {
            if (document.querySelector('html').scrollTop == 0) {
                if (this.$store.getters.isDropped == 'cart') {
                    this.$store.dispatch('setDropped', null);
                    this.$nextTick(() => {
                        document.querySelector('.addtocart').style.display = 'none';
                    });
                }
            }
        });
        if (this.toolType == 'add') {
            this.addType = true;
        } else {
            this.addType = false;
        }
    },

    watch: {
        isDropped(element, oldVal) {
            if(element != 'cart' && oldVal != 'cart') {
                if (oldVal) {
                    this.lastOrder = document.querySelector('#' + oldVal).getAttribute('data-order');
                }
                if (element) {
                    this.newOrder = document.querySelector('#' + element).getAttribute('data-order');
                }
            }

            if (oldVal == null || oldVal == 'cart') {
                this.enterAnimation = 'fadeIn';
                this.leaveAnimation = 'd-none';

            } else if (element == null || element == 'cart') {
                this.leaveAnimation = 'd-none';

            } else {
                if (this.lastOrder > this.newOrder) {
                    this.enterAnimation = 'slideInLeft';
                    this.leaveAnimation = 'slideOutRight';
                } else {
                    this.enterAnimation = 'slideInRight';
                    this.leaveAnimation = 'slideOutLeft';
                }
            }

            this.$nextTick(() => {
                let heightMenu = parseInt(document.querySelector('#solid-menu').offsetHeight);
                if (element && element != 'cart') {
                    document.querySelector('.animation').style.height = document.querySelector('#' + element).offsetHeight - 5 + 'px';
                    PathUtils.autoZoom(parseInt(document.querySelector('#' + element).offsetHeight) + heightMenu);
                } else {
                    document.querySelector('.animation').style.height = 0;
                }
            });
        },
        toolType() {
            if (this.toolType == 'add') {
                this.addType = true;
            } else {
                this.addType = false;
            }
        },
        materialName() {
            if (this.materialName == 'Metal') {
                this.color = '#dbd8d8'
            } else {
                this.color = '#eab875'
            }
        },
        pieces() {
            this.pieceInError = false;
            this.pieces.forEach(piece => {
                if (!piece.validSize) {
                    this.pieceInError = true;
                }
            });
        },
        multitouch(){
            if (this.multitouch) {
              this.drop(null);
            } 
        }
    },
    computed: {
        ...mapGetters([
            'loadingStep',
            'mode',
            'center',
            'zoom',
            'pieces',
            'totalPrice',
            'isDropped',
            'selectedShapeIds',
            'toolType',
            'toolSelected',
            'tool',
            'materialName',
            'selectedShape',
            'mobile',
            'multitouch'
        ]),
        uniquePieces: function() {
            return this.pieces ? this.pieces.filter(p => !p.isCopyOf) : []
        }
    },
    methods: {
        drop(element) {
            if (element == 'setting' && !this.selectedShapeIds.length) {
                this.$store.dispatch('setDropped', null);
            } else if (this.isDropped == element) {
                this.$store.dispatch('setDropped', null);

                if (element == 'cart') {
                        this.scroll(0);
                }
            } else {
                this.$store.dispatch('setDropped', element);

                if (element == 'cart') {
                    this.$nextTick(() => {
                        this.scroll(document.getElementById('menu-mobile'))
                    });
                } else {
                    this.$nextTick(() => {
                        this.scroll(0)
                    });
                }
            }
        },
        scroll(element) {
            if (element == 0) {
                document.querySelector('#header-mobile').scrollIntoView({ behavior: 'smooth' });
            } else {
                var target = element.offsetTop;
                window.scroll({top: target, left: 0, behavior: 'smooth'});
            }
        },
        removeShape: function(shape) {
            this.$store.dispatch('removeShapeId', shape.id);
            this.$store.dispatch('setSelectedShapes', []);
            this.$store.dispatch('setHeightPos', null);

            let selectionRectangle = paper.project.getItem({ name: "selection" });
            selectionRectangle.remove();

            this.drop(null);

            paper.project.layers.selecter.removeChildren();
        },
        async onJsHomeReturn(){
            if(window.obelix.onJsHomeReturn) window.obelix.onJsHomeReturn();
        },
    }
};
</script>

<style lang="scss">
    @import './../../assets/scss/_variables.scss';

    .JsEditorMobile {
        #header-mobile {
            z-index: 1;
            position: relative;
            background: white;
        }
        
        .btn {
            font-size: .9rem;
        }
    }

    .menu-mobile-item {
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: center;

        button {
            background-color: #e6e9f0!important;
            width: 100%;


            svg {
                height: 36px;
            }
        }
    }

    .pieceInError.filled {
        background: $jaune!important;

        #qty {
            background: $rose!important;
        }

        .text-white {
            color: #6c757d!important;
        }

        .choice {
            background: $jaune!important;
        }
    }

    .title-menu-mobile {
        font-size: 1.25rem!important;
        font-weight: bold!important;
    }

    #logo-mobile {
        height: 45px!important;
    }

    .dropdown-menu-mobile {
        position: relative;
        z-index: -1;
        margin-bottom: 10px;
        transition: all .3s ease-in-out;
    }

    .dropdown-menu-mobile.slideInUp,
    .dropdown-menu-mobile.slideOutDown {
        .animated {
            position: absolute;
            left: 0;
            width: 100%;
            bottom: 0;
        }
    }

    .slideInLeft[data-order="1"],
    .slideInRight[data-order="1"],
    .slideInRight[data-order="2"] {
        ~.animated[data-order="3"] {
            display: none;
        }
    }

    .slideInLeft[data-order="2"] {
        ~.animated[data-order="1"] {
            display: none;
        }
    }


    .animation {
        transition: all .3s ease-in-out!important;
    }

    .animated {
        animation-duration: .5s!important;
    }

    #sav-call {
        height: 20px;
    }

    #mobile-tools {
        .dropdown-menu-content {
            bottom: 75px;
        }

        svg {
            * {
                transition: all .3s ease-in-out;
            }

            &.active {
                path {
                    transform: translate(-3px, -2px)!important;
                }
                rect {
                    transform: translate(-9px, -5px) scale(1.2);
                    stroke: $jaune;
                    stroke-width: 3px;
                }
                circle {
                    transform: translate(-1px, -20px);
                }
            }
        }
    }

    #mobile-matters {
        .dropdown-menu-content {
            bottom: 68px;
        }

        svg {
            * {
                transition: all .3s ease-in-out;
            }

            &.active {
                path {
                    transform: rotate(-20deg) scale(1.1) translate(-4px, -2px);
                }
                rect {
                    stroke: $jaune;
                    stroke-width: 3px;
                    transform: rotate(10deg) scale(1.1) translate(2px, -15px);
                }
            }
        }
    }

    #mobile-settings {
        .dropdown-menu-content {
            bottom: 73px;
        }

        svg {
            * {
                transition: all .3s ease-in-out;
            }

            &.active {
                circle {
                    stroke: $jaune;
                    stroke-width: 3px;
                    // transform: rotate(10deg) scale(1.1) translate(2px, -15px);
                }

                #one {
                    transform: translate(20px);
                }
                #two {
                    transform: translate(30px);
                }
                #three {
                    transform: translate(-25px);
                }
            }
        }
    }

    #mobile-cart {
        transition: all .3s ease-in-out;

        img {
            transition: all .3s ease-in-out;
        }

        .active {
            #cart-mobile {
                img {
                    transform: rotate(-10deg);
                }
                span {
                    @media (min-width: 576px) {
                        transform: scale(1.2) rotate(5deg);
                    }
                }
            }
        }

        .dropdown-menu-content {
            transform-origin: top;
            max-height: 1000px;
            border-radius: 0 0 10px 10px;
            position: absolute;

            left: 0;
            width: 100%;
            z-index: -1;

            @media (max-width: 768px) {
                border-radius: 0;
            }
        }
    }

    .dropdown-menu-content .header {
        position: relative;
        z-index: 1;
    }

    #menu-mobile {
        .custom-switch {
            @media (min-width: 768px) {
                top: -2px;
            }
        }
    }
</style>
